<script>
import { mapGetters } from 'vuex';
import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportTrackerNames',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: 'Search Tracker Names',
    };
  },
  computed: {
    ...mapGetters(['lessonsTrackerNames']),
    getOptions() {
      let names = this.lessonsTrackerNames;
      names = names.filter((t) => t);
      names.sort();
      return names.map((t) => {
        return {
          label: t,
          value: t,
        };
      });
    },
    formattedValue() {
      const multiple = this.schema?.multiple;
      if (!multiple) {
        return this.value;
      }

      let value = Array.isArray(this.value) ? this.value : [this.value];
      return value.filter((v) => v);
    },
  },
};
</script>
